// extracted by mini-css-extract-plugin
export default {"root":"LiveDemosButton_root__zTatc","blink":"LiveDemosButton_blink__ch2bk"};